export default __webpack_public_path__ + "static/google-play-icon-eb4f576bd3f0f2c0c6f8ddee941af6d0.png";